import script from "./ContactoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactoPage.vue?vue&type=script&setup=true&lang=js"

import "./ContactoPage.vue?vue&type=style&index=0&id=0eafe3fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eafe3fc"]])

export default __exports__